import { gql } from 'graphql-request';
import { ResponsiveImageType } from 'react-datocms';
import { responsiveImage } from '../helpers/imageGeneric';

export const tooltipData = gql`
id
active: activeTooltip
image {
  ${responsiveImage({ params: { auto: 'format' } })} 
}
filters: tooltipFilter {
  ... on AlgoliaFilterAndRecord {
    id
    filterType: _modelApiKey
    filters {
      ... on AlgoliaFilterRecord {
        id
        attributeValue
        attributeName
        attributeExclusion
        type: _modelApiKey
      }
    }
  }
  ... on AlgoliaFilterOrRecord {
    id
    filterType: _modelApiKey
    filters {
      ... on AlgoliaFilterRecord {
        id
        attributeValue
        attributeName
        attributeExclusion
        type: _modelApiKey
      }
    }
  }
}
link
content
title
`;
export const tooltipconfigGql = gql`
    allTooltipConfigs{${tooltipData}}
`;

export const tooltipContentGql = gql`
  configTooltipContent{
    ${tooltipData}
  }
`;

export type TTooltipConfig = {
  id?: string;
  _modelApiKey?: string;
  active?: boolean;
  image?: { responsiveImage: ResponsiveImageType };
  filters?: any;
  link?: string;
  content?: string;
  title?: string;
};
